function submitBIS() {

  const contactForm = document.querySelector('#BIS_form');
  const submitButton = document.getElementById('BISSubmit');
  
  const WebhookUrl = "https://webhook.luggage-central.com/api/webhooks/bis/subscribe";

  contactForm.addEventListener(
    'submit',
    (event) => {
      event.preventDefault();

      // Disable the submit button
      submitButton.disabled = true;

      // Serialize form data
      const formData = new FormData(contactForm);
      const formObject = {};
      formData.forEach((value, key) => {
        formObject[key] = value;
      });

    fetch(WebhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(formObject),
    })
    .then((response) => response.json())
    .then((data) => {
      if (data.success) {
        document.getElementById("BIS_form_success_notice").classList.add("show");
        document.getElementById("BISSubmit").classList.add("hide_input");
      } else {
        console.error('BIS error:', data.error);
        // optionally show error message to user
      }
    })
    .catch((error) => {
      console.error('Network error:', error);
    })
    .finally(() => {
      submitButton.disabled = false;
    });
    },
  );
}
